import React from 'react';
import './ReceiptPreview.scss'

const ReceiptPreview = (props) => {
    const name = localStorage.getItem('storeName')

    return (
        <div className='preview'>
            <p className='store-name'>{name}</p>
            <p className='price'>결제금액 : 20,000원</p>
            <p className='point-text'>적립 포인트</p>
            <p className='point'>2,000P</p>
            <img src={require('../../aseets/icons/manual_qr.png')} className='qrcode'/>
            <p className='seed'>JOELDIOLENADLETE</p>
            <p className='intro'>{props.intro}</p>
            <p className='logo-name'>시럽프렌즈</p>
        </div>
    )
}

export default ReceiptPreview;